import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { theme } from './theme';

function PublicFooter() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.colors.surface,
        borderTop: `1px solid ${theme.colors.border}`,
        padding: '24px 20px',
        textAlign: 'center',
      }}
    >
      {/* Verstaani Logo */}
      <Link
        href="https://verstaani.fi"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          display: 'inline-block',
          textDecoration: 'none',
          '&:hover': {
            opacity: 0.8,
          },
        }}
      >
        <Box
          component="img"
          src="/img/logo-smaller.png"
          alt="Verstaani"
          sx={{
            height: '32px',
            marginBottom: '12px',
          }}
        />
      </Link>

      {/* Marketing text */}
      <Typography
        sx={{
          fontSize: '13px',
          color: theme.colors.textMuted,
          maxWidth: '300px',
          margin: '0 auto',
          lineHeight: 1.5,
        }}
      >
        Nykyaikainen toiminnanohjaus autokorjaamoille.
        Tehosta työnkulkua ja pidä asiakkaat ajan tasalla.
      </Typography>

      {/* Link to website */}
      <Link
        href="https://verstaani.fi"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          display: 'inline-block',
          marginTop: '12px',
          fontSize: '12px',
          color: theme.colors.accent,
          textDecoration: 'none',
          fontWeight: 500,
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        verstaani.fi
      </Link>
    </Box>
  );
}

export default PublicFooter;
